import styled, { keyframes } from 'styled-components';
import VariableBubble from '../../images/variable-bubble.svg';
import { Modal } from 'antd';
import * as palette from '../../styles/variables';

const slideInDown = keyframes`
0% { clip-path: inset(0 0% 60% 0); }
50% { clip-path: inset(0 0% 0% 0); }
100% { clip-path: inset(0); }
`;

const slideIn = keyframes` 
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
`;

export const Container = styled.main`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;

export const Wrapper = styled.section`
  height: 100%;
  flex-grow: 1;
  display: flex;
  overflow: hidden;
`;

export const PreviewContainer = styled.div`
  height: ${props => (props.previewPopup ? '78vh' : props.isEmpty ? '65vh' : 'calc(100vh - 70px)')};
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Open Sans', sans-serif;
  transition: width 0.1s ease-in-out !important;
  padding-left: ${props => props.showVersions && '10%'};
  justify-content: ${props => props.isEmpty && 'center'};
  .ant-empty {
    margin-top: ${props => props.isEmpty && '0 !important'};
  }
  .ant-empty-description {
    font-size: ${props => props.isEmpty && '16px !important'};
    color: ${props => props.isEmpty && '#747373'};
  }

  @media (max-width: 1460px) {
    height: ${props => props.previewPopup && '88vh'};
  }
  @media (max-width: 768px) {
    height: ${props => props.previewPopup && '90vh'};
  }
`;

export const EditingContainer = styled.div`
width: ${props => (props.messageStudio ? '' : '100%')};
  max-width: ${props => (props.messageStudio ? '' : '824px')}; // 794px + 30px(ruler-horizontal)
  height: ${props => (props.messageStudio ? '' : '1153px')}; // 794px + 30px(ruler-vertical)
  position: ${props => (props.messageStudio ? '' : 'relative')};
  margin: ${props => (props.messageStudio ? '' : 'auto')};
  background-color:${props =>
    props.transparent || props.messageStudio ? 'transparent' : '#f5f8fa'} ;
  .variable-popup {
    position: absolute;
    z-index: 5000;

    .ant-popover-content .ant-popover-arrow {
      background-color: #fc6e51;
      border-color: #fc6e51;
    }

    .ant-popover-inner-content {
      background-color: #fc6e51;
    }

    .ant-popover-inner {
      z-index: 4;
    }

    .ant-btn {
      border-width: 0;
      padding: 0;
      background-color: #fc6e51;
    }
  }

      .quill{
        @media (max-width: 991px){
      height: ${props => props.isCall && '160px !important'}
      }
      @media (min-width: 992px) and (max-width: 1200px) {
      height:  ${props => props.isCall && '160px !important'};
      }
      @media (min-width: 1201px) and (max-width:1400px){
      height:  ${props => props.isCall && '210px !important'};
      }
      @media (min-width: 1401px) and (max-width:1600px){
      height:  ${props => props.isCall && '190px !important'};
      }
      @media (min-width: 1601px) and (max-width:1920px){
      height:  ${props => props.isCall && '235px !important'};
      }
      @media (min-width: 1921px) and (max-width:2560px){
      height:  ${props => props.isCall && '212px !important'};
      }
    }

  .ql-container {
    height:  ${props => props.isCall && '100%'};
    font-family: 'Open Sans';
    min-width: ${props => (props.messageStudio ? '6pt' : '')};
  }

  .ql-snow {
    border: initial !important;

    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
    .ql-editor {
      padding: 0px;
      overflow: visible !important;
      height:  ${props => props.isCall && '100%'};
      width:  ${props => props.isCall && '100%'};
      text-align: ${props => props.isCall && 'center'};
      overflow: hidden !important;
      overflow-y: auto !important;
      ::-webkit-scrollbar {
        display: none !important;
      }
      &[contenteditable='false'] {
        p {
          user-select: ${props => (props.variablesLayoutEnabled ? 'auto' : 'none')};
          cursor: default;
        }
        ol,
        ul {
          cursor: default;
        }
      }
    }
    mark {
      font-size: inherit;
      background-color: inherit;
      color: inherit;
    }
    mark[data-vtype='assigning'],
    mark[data-vtype='assigned'] {
      color: #666666;
    }
    mark[data-vtype='assigning'] {
      background-color: rgb(50, 143, 236);
      color: rgb(255, 255, 255);
    }
    mark[data-vtype='assigned'] {
      outline: 0.5px dashed #000000;
      position: relative;
      background: rgb(251 251 159 / 50%);
      &::before {
        position: absolute;
        content: attr(data-vlength);
        font-family: ${palette.FONT_FAMILY} !important;
        top: -38px;
        left: 50%;
        transform: translateX(-50%);
        background-image: url(${VariableBubble});
        background-repeat: no-repeat;
        width: 36px;
        height: 47px;
        font-size: 12px;
        font-weight: 600;
        color: #fff;
        text-align: center;
        z-index: 10;
        padding: 7px;
        cursor: pointer;
      }
    }

    .mention {
      height: 24px;
      width: 65px;
      border-radius: 6px;
      background-color: #d3e1eb;
      padding: 3px 0;
      margin-right: 2px;
      user-select: all;
    }
    .mention > span {
      margin: 0 3px;
    }
  }
`;

export const EditorWrapper = styled.div`
  width: ${props => (props.messageStudio ? '' : '100%')};
  flex-grow: ${props => (props.messageStudio ? '' : '1')};
  flex-shrink: ${props => (props.messageStudio ? '' : '0')};
  margin: ${props => (props.messageStudio ? '' : '0px auto')};
  padding: ${props => (props.messageStudio ? '' : '24px 0px')};
  display: ${props => (props.messageStudio ? '' : 'flex')};
  &:last-child {
    margin-bottom: ${props => (props.messageStudio ? '' : '35px')};
  }
  .moveable-padding {
    background-color: rgb(68 170 255 / 15%);
  }
  .moveable-padding::after {
    position: absolute;
    content: '';
    background: rgb(68 170 255 / 1);
    width: 100%;
    height: 25px;
  }
  @media only screen and (max-width: 1440px) {
    padding-right: ${props => (props.messageStudio ? '' : '10px !important')};
  }
`;

export const TabsContainer = styled.div`
  margin: ${props => (props.popupPreview ? '0px 0px 35px 0px' : '35px 0 15px 0')};
  min-width: ${props => (props.tabsWidth === 2 ? '20vw' : '30vw')};
  padding: ${props => (props.tabsWidth === 2 ? '3px' : props.popupPreview ? '3px 0 3px 3px' : '')};
  background-color: #333;
  display: flex;
  border-radius: 99px;
  z-index: 1;
  @media (max-width: 1460px) {
    margin: ${props => props.popupPreview && '20px 0px 20px 0px'};
  }
  @media (max-width: 768px) {
    margin: ${props => props.popupPreview && '10px 0px 15px 0px'};
  }
  .Tabs {
    min-height: 6vh;
    width: ${props => (props.tabsWidth === 2 ? '50%' : '33%')};
    color: #fff;
    font-size: 1vw;
    font-weight: bold;
    text-transform: uppercase;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    cursor: pointer;
    border-radius: 99px;
  }
  .gradient-pill {
    min-height: 6vh;
    width: 100%;
    background-image: linear-gradient(to left, #b97bdb, #b29efa, #7c66ff);
    position: absolute;
    z-index: -1;
    cursor: pointer;
    border-radius: 99px;
    transition: 0.2s ease transform;
  }
  .Check {
    position: absolute;
    top: -28%;
    @media (max-width: 1460px) {
      top: -32%;
    }
    @media (max-width: 768px) {
      top: -22%;
    }
    @supports (animation: grow 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards) {
      .tick {
        stroke-opacity: 0;
        stroke-dasharray: 29px;
        stroke-dashoffset: 29px;
        animation: draw 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards;
        animation-delay: 0.6s;
      }
      .circle {
        fill-opacity: 0;
        stroke: url(#MyGradient);
        stroke-width: 16px;
        transform-origin: center;
        transform: scale(0);
        animation: grow 1s cubic-bezier(0.25, 0.25, 0.25, 1.25) forwards;
      }
    }
    @keyframes grow {
      60% {
        transform: scale(0.8);
        stroke-width: 4px;
        fill-opacity: 0;
      }
      100% {
        transform: scale(0.9);
        stroke-width: 8px;
        fill-opacity: 1;
        fill: url(#MyGradient);
      }
    }
    @keyframes draw {
      0%,
      100% {
        stroke-opacity: 1;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
  }
`;

export const TabsContent = styled.div`
  .slides-enter {
    opacity: 0;
    transform: translateX(-100%);
  }
  .slides-enter-active {
    opacity: 1;
    transform: translateX(0%);
  }
  .slides-exit {
    opacity: 1;
    transform: translateX(0%);
  }
  .slides-exit-active {
    opacity: 0;
    transform: translateX(100%);
  }
  .slides-enter-active,
  .slides-exit-active {
    transition: opacity 500ms, transform 500ms;
  }
  height: ${props =>
    props.currentVersion === 'draft' ? 'calc(100% - 6vh - 50px)' : 'calc(100vh - 50px)'};
  width: ${props => (props.isSideBar ? 'calc(100vw - 350px)' : 'calc(100vw - 75px)')};
  position: relative;
  display: flex;
  align-items: center;
  --total: 3;
  .section-divs {
    --size: 20vw;
    --gap: ${props => (props.isSideBar ? '2vw' : '6vw')};
    height: 100%;
    width: var(--size);
    position: absolute;
    top: ${props => !props.showVersions && '0'};
    left: calc(
      50% - var(--size) / 2 - (var(--num-selected) - var(--place) * 2 + 1) *
        (var(--size) / 2 + var(--gap) / 2)
    );
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.4s ease-in-out !important;
    @media (max-width: 1024px) {
      --size: 220px;
      flex-wrap: wrap;
    }
    @media (max-width: 1440px) {
      height: auto;
    }
  }
  .popup-section-divs {
    position: absolute;
    top: 0;
    left: calc(50% - 10vw);
    width: 20vw;
  }
  .disable-pointer-events {
    .ql-editor {
      & > * {
        pointer-events: none;
      }
    }
  }
  .section-divs[data-selected='false'] {
    top: 312.2px;
    left: calc(50% - var(--size) / 2 - (var(--total) - var(--place) * 2 + 1) * var(--size) / 4);
    opacity: 0;
    @media (max-width: 1460px) {
      top: 250px;
    }
  }
  @media (max-width: 1460px) {
    column-gap: 64px;
  }
  @media (max-width: 1440px) {
    overflow-y: ${props => !props.showVersions && 'scroll'};
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .fade-enter {
    opacity: 0;
    transform: translateY(100%);
  }
  .fade-enter-active {
    opacity: 1;
    transform: translateY(0%);
  }
  .fade-exit {
    opacity: 1;
    transform: translateY(0%);
  }
  .fade-exit-active {
    opacity: 0;
    transform: translateY(100%);
  }
  .fade-enter-active,
  .fade-exit-active {
    transition: opacity 300ms, transform 300ms;
  }
  .Voice-Message {
    width: 100%;
    height: ${props => (props.popupPreview ? '62vh' : '78%')};
    border-radius: 36px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
      rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0.8%;
    background-image: linear-gradient(
      60deg,
      #f79533,
      #f37055,
      #ef4e7b,
      #a166ab,
      #5073b8,
      #1098ad,
      #0998ad,
      #08a39b
    );
    text-align: center;
    @media (max-width: 1460px) {
      height: 480px;
      border-radius: 26px;
    }
    @media (max-width: 1024px) {
      height: 386px;
      border-radius: 16px;
    }
    .title {
      margin: 4% 0;
      font-size: 1vw;
      font-weight: bold;
      text-transform: uppercase;
      color: #fff;
    }
    .ql-container.ql-snow {
      border: 0;
    }
    .ql-editor > p {
      text-align: left;
      font-style: normal;      
      word-break: break-word;
      @media (max-aspect-ratio: 3/4) {
        font-size: 18px;
      }
      @media (min-aspect-ratio: 4/3) {
        font-size: 18px;
        @media (max-width: 1460px) {
          font-size: 14px;
        }
      }
      @media (min-aspect-ratio: 3/4) and (max-aspect-ratio: 1/1) {
        font-size: 16px;
      }
      @media (min-aspect-ratio: 1/1) and (max-aspect-ratio: 4/3) {
        font-size: 12px;
      }
    }
    .call-container {
      width: 100%;
      height: 70%;
      padding: 8% 6% 32% 6%;
      border: 0;
      outline: none;
      border-radius: 36px;
      resize: none;
      color: #000;
      font-style: italic;
      font-size: 13px;
      background-color: #faf8ff;
      text-align: center;
      position: relative;
      @media (max-width: 1460px) {
        border-radius: 26px;
      }
      @media (max-width: 1024px) {
        border-radius: 16px;
      }
      ::-webkit-input-placeholder {
        font-style: italic;
      }
      :-moz-placeholder {
        font-style: italic;
      }
      ::-moz-placeholder {
        font-style: italic;
      }
      :-ms-input-placeholder {
        font-style: italic;
      }
    }
    .Voice-Msg-Footer {
      position: absolute;
      bottom: 1%;
      background-color: #d3e4cd;
      height: 36%;
      width: 94%;
      border-radius: 36px;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
        rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
      display: flex;
      justify-content: center;
      @media (max-width: 1460px) {
        border-radius: 26px;
      }
      @media (max-width: 1024px) {
        border-radius: 16px;
      }
    }
    .Voice-Msg-Footer-Div {
      position: absolute;
      top: -6%;
      background-color: #000;
      height: 100%;
      width: 94%;
      border-radius: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .callCharLimit {
        width: 75%;
        color: #f7f7f7;
        font-size: 0.7vw;
        padding-top: 12px;
      }
      @media (max-width: 1460px) {
        top: -4%;
        border-radius: 26px;
      }
      @media (max-width: 1024px) {
        border-radius: 16px;
      }
      button {
        position: absolute;
        right: 50%;
        transform: translate(50%, -50%);
        top: 0;
        height: 7.8vh;
        width: 7.8vh;
        border-radius: 100%;
        background-image: linear-gradient(to right, #478c76, #8ace90);
        color: #f1f1f1;
        outline: none;
        border: 7.5px solid #faf8ff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        @media (max-width: 1460px) {
          height: 4.8vw;
          width: 4.8vw;
        }
        @media (max-width: 1024px) {
          height: 5.6vw;
          width: 5.6vw;
        }
        i {
          font-size: 1.2vw;
          cursor: ${props => props.vmEmpty && 'not-allowed'};
          opacity: ${props => props.vmEmpty && '0.4'};
          @media (max-width: 1460px) {
            font-size: 18px;
          }
        }
      }
      button:before {
        content: '';
        position: absolute;
        top: 50%;
        left: -25px;
        width: 20px;
        height: 20px;
        background: #000;
        border-top-right-radius: 22px;
        box-shadow: 1px -8px 0 0 #faf8ff;
        pointer-events: none;
        cursor: default;
      }
      button:after {
        content: '';
        position: absolute;
        top: 50%;
        right: -25px;
        width: 20px;
        height: 20px;
        background: #000;
        border-top-left-radius: 22px;
        box-shadow: -1px -8px 0 0 #faf8ff;
        pointer-events: none;
        cursor: default;
      }
      .playing:before {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        display: block;
        width: 72px;
        height: 72px;
        background: #1f4037;
        border-radius: 50%;
        animation: pulse-border 1500ms ease-out infinite;
        z-index: 1000;
      }
      .disabled {
        background: rgb(221 221 221) !important;
        cursor: not-allowed !important;
        pointer-events: none;
      }
      @keyframes pulse-border {
        0% {
          transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
          opacity: 1;
        }
        100% {
          transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
          opacity: 0;
        }
      }
    }
    .Voice-Option {
      .ant-select-selection--single {
        padding: 14px;
        background: transparent;
        border: 1px solid #d6dbd6;
        font-family: 'Open Sans', sans-serif;
        font-size: 1vw;
        width: 100%;
        height: 10%;
        color: #d6dbd6;
        display: flex;
        align-items: center;
        .ant-select-arrow svg {
          color: #d6dbd6;
        }
        @media (max-width: 1460px) {
          font-size: 12px;
          height: 44px;
        }
        @media (max-width: 1024px) {
          font-size: 0.9vw;
          margin: 0 auto;
          width: 86%;
          height: 28px;
          justify-content: flex-end;
          padding-left: 18px;
        }
      }
    }
  }
`;

export const View = styled.div`
  .Phone {
    background-color: #f1f1f1;
    border-radius: 36px;
    height: ${props => (props.popupPreview ? '62vh' : '78%')};
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-shadow: 5px 10px 10px rgba(0, 0, 0, 0.4), inset -5px -10px 20px rgba(0, 0, 0, 0.2);
    z-index: ${props => (props.active === 0 ? 2 : 1)};
    @media (max-width: 1460px) {
      border-radius: 26px;
      height: 480px;
    }
    @media (max-width: 1024px) {
      border-radius: 16px;
      height: 386px;
    }
    .Features-Top {
      height: 8%;
    }
    .Bottom {
      height: 11%;
    }
  }
  .Screen {
    position: relative;
    width: 92%;
    height: 81%;
    overflow: visible;
    border-radius: 9px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    background-size: cover;
    background-color: #fff;
    @media (max-width: 1460px) {
      border-radius: 4px;
    }
  }
  .Header {
    width: 100%;
    height: 12%;
    background-color: #000;
    display: flex;
    align-items: center;
    color: #f1f1f1;
    text-align: center;
    font-size: 0.8vw;
    i {
      text-align: center;
      flex-basis: 12%;
    }
    .Contact {
      flex-basis: ${props => (props.active == 0 ? '52%' : '64%')};
      text-align: left;
      font-size: 1vw;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  .Main {
    width: 100%;
    height: 88%;
  }
  .Main::-webkit-scrollbar {
    display: none;
  }
  .MessageContainer {
    .Today {
      display: flex;
      justify-content: center;
      p {
        text-align: center;
        margin: 7.5px 0;
        padding: 2.5px;
        text-transform: uppercase;
        border-radius: 5px;
        font-size: 0.8vw;
        min-width: 60px;
        background-color: #d8ebf2;
        @media (max-width: 1460px) {
          font-size: 10px;
          width: 38px;
        }
        @media (max-width: 1024px) {
          padding: 1px;
          font-size: 8px;
          min-width: 12px;
        }
      }
    }
    .Message {
      padding: 10px;
      position: relative;
      right: ${props => (props.active == 0 ? '15px' : '7.5px')};
      color: ${props => (props.active == 0 ? '#000' : '#fff')};
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
      margin: 7.5px 0;
      max-width: 78%;
      background: ${props => (props.active == 0 ? '#e1ffc7' : '#d9e6f2')};
      float: right;
      border-radius: ${props =>
        props.active == 0 ? '6.25px 0px 6.25px 6.25px' : '15px 0px 15px 15px'};
      .ql-container {
        font-size: 13px;
      }
      p {
        @media (max-aspect-ratio: 3/4) {
          font-size: 18px;
        }
        @media (min-aspect-ratio: 4/3) {
          font-size: 18px;
          @media (max-width: 1460px) {
            font-size: 14px;
          }
        }
        @media (min-aspect-ratio: 3/4) and (max-aspect-ratio: 1/1) {
          font-size: 16px;
        }
        @media (min-aspect-ratio: 1/1) and (max-aspect-ratio: 4/3) {
          font-size: 12px;
        }
        color: #000;
      }
      @media (max-width: 1460px) {
        padding: 8px;
        right: ${props => (props.active == 0 ? '12px' : '6px')};
        margin: 6px 0;
        border-radius: ${props => (props.active == 0 ? '5px 0px 5px 5px' : '12px 0px 12px 12px')};
      }
      .ql-snow .ql-editor {
        padding: 0px;
        max-height: 225px !important;
        overflow: hidden !important;
        overflow-y: auto !important;
        ${props => (props.popupPreview || props.showVersions) && `
          & > * {
            pointer-events: none;
          }
        `};
        ::-webkit-scrollbar {
          display: none;
        }
      }
    }
    .Message:after {
      display: ${props => (props.active == 1 ? 'none' : 'block')};
      position: absolute;
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      top: 0;
      right: -7.5px;
      border-width: 0px 0 12.5px 12.5px;
      border-color: transparent transparent transparent
        ${props => (props.active == 0 ? '#e1ffc7' : '#dee0ed')};
      @media (max-width: 1460px) {
        right: -10px;
        border-width: 0px 0 10px 10px;
      }
    }
    .Time {
      color: ${props => (props.active == 0 ? '#b9b9b9' : '#333')};
    }
    .Time,
    .Tick {
      font-size: 0.7vw;
      float: right;
    }
    .Tick {
      margin-left: 4px;
      width: 0.9vw;
      filter: invert(69%) sepia(66%) saturate(1163%) hue-rotate(169deg) brightness(96%)
        contrast(103%);
    }
    .ql-snow .mention,
    .ql-snow span[data-list]::before,
    .ql-snow span[data-date]::before {
      background-color: ${props => props.active == 1 && '#c9c9c9'};
    }
  }
  .charLimit {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 0.7vw;
    background: #808080;
    padding: 5px;
    color: #fff;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-bottom-left-radius:  ${props =>
      props.active == 2 ? '26px' : props.active == 1 ? '4px' : ''};
    border-bottom-right-radius:${props =>
      props.active == 2 ? '26px' : props.active == 1 ? '4px' : ''};
    .maxLength {
      font-size: 8px;
      letter-spacing: 0.5px;
    }
    .approx {
      font-size: 14px;
    }
  }
  .Bottom {
    z-index: 0;
    display: flex;
    place-items: center;
    align-items: center;
    justify-content: center;
    @media (max-width: 1460px) {
      height: 58px;
    }
    .Button {
      height: 4.6vh;
      width: 4.6vh;
      border-radius: 50%;
      box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.7);
      transition: 0.1s;
      display: flex;
      place-items: center;
      justify-content: center;
      padding: 12px 0;
      @media (max-width: 1460px) {
        height: 38px;
        width: 38px;
      }
    }
    .Button .Square {
      height: 1.4vh;
      width: 1.4vh;
      border-radius: 1.25px;
      border: 1.25px solid #aaa;
      transition: 0.1s;
      @media (max-width: 1460px) {
        height: 10px;
        width: 10px;
        border-radius: 1px;
        border: 1px solid #aaa;
      }
    }
  }
`;

export const TestMessageModal = styled(Modal)`
  .ant-modal-body {
    padding: 0 34px 22px 34px !important;
  }
  .Sending-Icon-Text {
    display: inline;
    padding-left: 4px;
    font-style: italic;
    color: '#000';
  }
  .ErrorMsg {
    color: red;
    padding-bottom: 24px;
    text-align: center;
    font-family: 'Open Sans', sans-serif;
    font-style: italic;
    text-transform: none;
  }
`;

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  width: 100%;
`;

export const ModalTagContainer = styled.div`
  display: flex;
  align-items: center;
  border: ${props => (props.border ? '1px solid #000' : '1px solid #b9b9b9')};
  border-radius: 8px;
  padding: 10px 10px 0px 10px;
  flex-wrap: wrap;
  .ant-tag {
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    padding: 4px 7px;
    margin: 0px 10px 10px 0px;
  }
  .ant-tag .anticon-close {
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #df4c35 !important;
    background: #fff !important;
    padding: 2px !important;
    border-radius: 25px !important;
    margin-left: 10px !important;
  }
  .ant-input {
    border: none !important;
    outline: none !important;
    margin-bottom: 10px !important;
    color: #171717 !important;
    ::placeholder {
      color: #767676 !important;
    }
    &.ant-input:focus {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }
  }
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const ShortMessageCheckbox = styled.fieldset`
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  user-select: none;
  margin: 1.2rem 0;
  column-gap: 4px;
  & > * {
    margin: 0.2rem 0.2rem;
  }
  .Checkbox-Wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-basis: ${props =>
      props.errorCase ? (props.length === 1 ? '100%' : props.length === 2 ? '50%' : '33%') : ''};
  }
  .Checkbox {
    position: relative;
    top: 0;
    left: 0;
    height: 2.6rem;
    width: 8.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    border: none;
    z-index: 1;
    color: #000;
    background: #004466;
    transition: all 0.3s ease;
    cursor: ${props => (!props.errorCase ? 'pointer' : '')};
    span {
      font-family: 'Open Sans', sans-serif;
      font-style: italic;
      color: #fff;
    }
  }
  .Checkbox:after {
    position: absolute;
    content: '';
    width: 0;
    height: 100%;
    top: 0;
    right: 0;
    z-index: -1;
    background-color: #000;
    opacity: 0.5;
    transition: all 0.3s ease;
  }
  .Slide-Effect:after {
    left: 0;
    width: 100%;
  }
  .Check {
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translate(-50%, -50%);
    @supports (animation: growModalCheckbox 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards) {
      .tick {
        stroke-opacity: 0;
        stroke-dasharray: 29px;
        stroke-dashoffset: 29px;
        animation: drawModalCheckbox 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards;
        animation-delay: 0.6s;
      }
      .circle {
        fill-opacity: 0;
        stroke: url(#MyGradientModalCheckbox);
        stroke-width: 16px;
        transform-origin: center;
        transform: scale(0);
        animation: growModalCheckbox 1s cubic-bezier(0.25, 0.25, 0.25, 1.25) forwards;
      }
    }
    @keyframes growModalCheckbox {
      60% {
        transform: scale(0.8);
        stroke-width: 4px;
        fill-opacity: 0;
      }
      100% {
        transform: scale(0.9);
        stroke-width: 8px;
        fill-opacity: 1;
        fill: url(#MyGradientModalCheckbox);
      }
    }
    @keyframes drawModalCheckbox {
      0%,
      100% {
        stroke-opacity: 1;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
  }
  .Message,
  .Numbers {
    font-family: 'Open Sans', sans-serif;
    font-style: italic;
    text-align: center;
    font-size: 1vw;
    margin-top: 24px;
  }
  .Numbers {
    margin-top: 6px;
  }
`;

export const DesignModal = styled(Modal)`
  .design_form {
    overflow: hidden;
    height: 420px;
  }
  .ant-modal-content {
    animation: ${props => !props.categ && slideInDown} 2s ease-in-out !important;
  }
  .ant-modal-header {
    padding: ${props => (props.messageStudio ? '26px 34px !important' : '')};
  }
  .ant-modal-body {
    overflow: hidden;
    display: ${props => (props.messageStudio ? 'flex' : '')};
    padding: ${props =>
      props.messageStudio ? '0px 34px 24px 34px !important' : '34px !important'};
    justify-content: ${props => (props.messageStudio ? 'center' : '')};
  }
  p {
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
    white-space: normal;
    text-align: center;
  }
  .ant-modal-content {
    box-shadow: none !important;
  }
  .ant-modal-title {
    font-size: 18px !important;
    font-family: 'Open Sans', sans-serif;
    font-weight: 100 !important;
    text-transform: uppercase;
  }
  .ant-checkbox {
    margin-bottom: 10px;
  }
  .ant-checkbox-inner {
    width: 20px;
    height: 20px;
    border-color: transparent;
    background: transparent;
  }
  .ant-checkbox-wrapper {
    position: relative;
    height: 100px;
    width: 150px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${props => (props.messageStudio ? 'center' : 'flex-start')};
    padding-top: ${props => (props.messageStudio ? '0' : '2%')};
    margin: 3%;
    box-shadow: ${props =>
      props.messageStudio
        ? 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px'
        : 'rgb(50 50 93 / 25%) 0px 50px 100px -20px, rgb(0 0 0 / 30%) 0px 30px 60px -30px'};
    .ant-checkbox {
      display: ${props => (props.messageStudio ? 'none' : '')};
    }
    .ModalCheck {
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translate(-50%, -50%);
      @supports (animation: modalGrow 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards) {
        .ModalTick {
          stroke-opacity: 0;
          stroke-dasharray: 29px;
          stroke-dashoffset: 29px;
          animation: modalDraw 0.5s cubic-bezier(0.25, 0.25, 0.25, 1) forwards;
          animation-delay: 0.6s;
        }
        .ModalCircle {
          fill-opacity: 0;
          stroke: url(#modalGradient);
          stroke-width: 16px;
          transform-origin: center;
          transform: scale(0);
          animation: modalGrow 1s cubic-bezier(0.25, 0.25, 0.25, 1.25) forwards;
        }
      }
      @keyframes modalGrow {
        60% {
          transform: scale(0.8);
          stroke-width: 4px;
          fill-opacity: 0;
        }
        100% {
          transform: scale(0.9);
          stroke-width: 8px;
          fill-opacity: 1;
          fill: url(#modalGradient);
        }
      }
      @keyframes modalDraw {
        0%,
        100% {
          stroke-opacity: 1;
        }
        100% {
          stroke-dashoffset: 0;
        }
      }
    }
  }
  .ant-checkbox-wrapper:nth-child(1) {
    background: ${props => (props.messageStudio ? '#f58b70' : '#480a74')};
    color: #fff !important;
    span {
      padding-top: 10px;
      color: #000 !important;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      border-color: transparent !important;
      background: #ffec3c !important;
    }
    .ant-checkbox-inner::after {
      color: #000;
    }
  }
  .ant-checkbox-wrapper:nth-child(2) {
    background: ${props => (props.messageStudio ? '#f27393 !important' : '#479d9e !important')};
    color: #fff !important;
    span {
      padding-top: 10px;
      color: #000 !important;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      border-color: transparent !important;
      background: #1632a6 !important;
    }
    .ant-checkbox-inner::after {
      color: #fff;
    }
  }
  .ant-checkbox-wrapper:nth-child(3) {
    background: ${props => (props.messageStudio ? '#91afd4 !important' : '#ffec3c !important')};
    color: #fff !important;
    span {
      padding-top: 10px;
      color: #000 !important;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      border-color: transparent !important;
      background: #480a74 !important;
    }
    .ant-checkbox-inner::after {
      color: #fff;
    }
  }
  .ant-checkbox-wrapper.ant-checkbox-wrapper-checked:nth-child(1) {
    display: flex;
    justify-content: center;
    padding: 0 !important;
  }
  .ant-checkbox-wrapper.ant-checkbox-wrapper-checked:nth-child(2) {
    display: flex;
    justify-content: center;
    padding: 0 !important;
  }
  .ant-checkbox-wrapper.ant-checkbox-wrapper-checked:nth-child(3) {
    display: flex;
    justify-content: center;
    padding: 0 !important;
  }
  .ant-checkbox-group {
    display: flex;
    margin-top: 20px;
  }
  .selection-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .ant-checkbox-inner::after {
    position: absolute;
    top: 10%;
    left: 10%;
    background: transparent;
    font-size: 15px;
    font-weight: bold;
    border-top: 0;
    border-left: 0;
    border-radius: 8px;
    content: '✓';
  }
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: transparent !important;
  }

  .fade-enter .design_input {
    opacity: 0;
    transform: translateX(-100%);
  }
  .fade-enter-active .design_input {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit .design_input {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit-active .design_input {
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-enter-active .design_input,
  .fade-exit-active .design_input {
    transition: opacity 500ms, transform 500ms;
  }
  @media only screen and (min-width: 2560px) {
    .ant-checkbox-wrapper {
      height: 125px;
    }
  }
  .ant-checkbox-group {
    padding: 10px;
  }
  .ant-checkbox-group-item {
    margin: 5px;
  }
  .ant-checkbox + span {
    padding-right: 8px;
    padding-left: 8px;
    font-family: Raleway, sans-serif;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 2px;
    fill: #585858;
    color: #d8d6d6;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 0px 0px 0px 0px;
    @media only screen and (min-width: 1460px) {
      font-size: 12px;
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background: linear-gradient(to right, #ef9d43, #e75516);
    border-color: rgb(219, 57, 31);
    border: 2px solid rgb(219, 57, 31) !important;
  }
  .ant-checkbox-checked::after {
    border-color: rgb(219, 57, 31);
    border: 1px solid rgb(219, 57, 31);
  }
  .badge {
    font-size: 13px;
    height: 25px;
    width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgb(219, 57, 31) !important;
    margin-left: 10px;
    @media only screen and (max-width: 1460px) {
      font-size: 11px;
      height: 22px;
      width: 22px;
    }
  }
  .ant-modal-footer {
    border-top: initial !important;
    padding: 34px !important;
    padding-top: 0px !important;
    padding-bottom: 24px !important;
    text-align: center !important;
    .ErrorMsg {
      color: red;
      padding-bottom: 24px;
      text-align: center;
      font-family: 'Open Sans', sans-serif;
      font-style: italic;
      text-transform: none;
    }
  }
  .ant-modal-footer .ant-btn-primary {
    color: #fff !important;
    background: #000 !important;
    width: ${props => (props.reqApprovalButton ? '46%' : '40%')};
    border-radius: 20px;
  }
  .Sending-Icon-Text {
    margin: 24px 0;
    font-style: italic;
    text-transform: capitalize;
  }
  .BlurredCheckbox {
    opacity: 0.5;
  }
`;

export const PublishContainer = styled.div`
  height: 100%;
  top: 0px;
  left: ${props => (props.shortMessage ? '-75px' : '0px')};
  position: absolute;
  overflow-y: auto;
  z-index: 10000;
  animation: ${props => (props.display ? slideIn : 'none')} 0.5s ease-in-out;
  box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
  min-width: ${props => (props.shortMessage ? '220px' : '437px')};
  padding: 0 25px;
  background-color: rgba(2, 2, 2, 0.55);
  backdrop-filter: blur(10px);
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const PublishList = styled.ul`
  margin: ${props =>
    props.shortMessage ? '10px 0 0px 10px !important' : '10px 0 0px 50px !important'};
  border-bottom: 0.5px solid white;
  padding-bottom: 10px;
  li {
    min-height: 60px;
    width: 180px;
    align-items: center;
    display: flex;
    justify-content: flex-start;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;
    i {
      margin-right: 10px;
      font-size: 20px;
      color: #fff;
    }
    .column {
      display: flex;
      flex-direction: column;
    }
  }
  .note-text {
    font-size: 12px;
    color: hsla(0, 0%, 100%, 65%);
  }
  .active {
    color: #fff;
    transition: all 0.25s;
  }
`;

export const ToolbarView = styled.div`
  background-color: rgba(2, 2, 2, 0.55);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  height: 70px;
  z-index: 9990;
  width: 70%;
  padding-right: 25px;
  button {
    margin: 0 10px;
    background: #b1272c;
    color: #fff;
    border: 2px solid #b1272c;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    &:hover {
      background-color: #b1272c !important;
      border-color: #b1272c;
      color: #fff;
    }
  }
  i.anticon.anticon-close {
    margin: 0px 10px;
    color: #000;
    font-size: 15px;
    background-color: #fff;
    padding: 8px;
    border-radius: 50%;
  }
  svg.svg-icon {
    width: 20px !important;
    height: 20px !important;
  }
`;

export const ListView = styled.div`
  li {
    color: ${props => (props.activeVersion ? '#fff' : 'hsla(0,0%,100%,65%)')};
    font-weight: 600;
    font-size: 15px !important;
    transform: ${props => props.activeVersion && 'scale(1.05)'};
    transition: all 0.25s;
    @media only screen and (min-width: 1460px) {
      font-size: 17px !important;
    }
    i {
      color: ${props => (props.activeVersion ? '#fff' : 'hsla(0,0%,100%,65%)')};
    }
  }
`;

export const TemplateOverview = styled.div`
  position: relative;
  width: 225px;
  height: 240px;
  margin: 10px 0px 0px 10px;
  transition: transform 0.2s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;
  .data-carousel {
    font-size: 18px;
    text-align: left;
    vertical-align: middle;
    margin: 50px 0px 0px 0px;
    font-weight: bold;
  }
  .template-media {
    position: relative;
    padding: 5px;
    border-radius: 10px;
    height: 200px;
    background: #fff !important;
    border: none;
    box-shadow: none;
    margin: 0;
  }
  .template-name {
    font-size: 16px;
    color: #fff;
    padding: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    text-transform: uppercase;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    h2 {
      font-family: ambroise-firmin-std, serif;
      color: #fff;
      font-size: 18px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
      text-align: center;
      max-width: 350px;
    }
  }
  .image-wrapper {
    img {
      max-height: 305px;
      object-fit: contain;
      &.no-thumbnail {
        height: 100%;
        margin-top: 15%;
      }
    }
  }
  .preview-button {
    background-color: rgba(14, 19, 24, 0.7);
    color: #ffffff;
    width: 22px;
    height: 18px;
    border-radius: 5px;
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 15px;
    right: 10px;
    font-size: 14px;
    .anticon {
      color: #fff;
    }
    &:hover {
      background-color: rgb(0 0 0 / 0.5);
    }
  }
  &:hover {
    cursor: pointer;
    transform: scale(1.05) translate(0px, 0px) perspective(500px);
    .dropdown-menu {
      display: flex;
    }
    .preview-button {
      display: flex;
    }
  }
`;
